import React, { Component } from "react";
import { Container, Row, Col } from 'react-bootstrap'
import {PropTypes} from 'prop-types'
import {connect} from 'react-redux'

import PageTitle from "./../components/common/PageTitle";
import SmallStats from "./../components/common/SmallStats";
import UsersByDevice from "./../components/UsersByDevice";
import UsersOverview from "./../components/UsersOverview";


class Dashboards extends Component {

    render() {
        const smallStats = this.props.smallStats;
        return (
             <Container fluid className="main-content-container px-4">
               {/* Page Header */}
               <Row noGutters className="page-header py-4">
                 <PageTitle title={this.context.t('Metrics')} subtitle={this.context.t('Dashboard')} className="text-sm-left mb-3" />
               </Row>

               {/* Small Stats Blocks */}
               <Row>
                 {smallStats.map((stats, idx) => (
                   <Col className="col-lg mb-4" key={idx} {...stats.attrs}>
                     <SmallStats
                       id={`small-stats-${idx}`}
                       variation="1"
                       chartData={stats.datasets}
                       chartLabels={stats.chartLabels}
                       label={this.context.t(stats.label)}
                       value={stats.value}
                       percentage={stats.percentage}
                       increase={stats.increase}
                       decrease={stats.decrease}
                     />
                   </Col>
                 ))}
               </Row>

               <Row>
                 {/* Users Overview */}
                 <Col lg="8" md="12" sm="12" className="mb-4">
                   <UsersOverview />
                 </Col>

                 {/* Users by Device */}
                 <Col lg="4" md="6" sm="12" className="mb-4">
                   <UsersByDevice />
                 </Col>
               </Row>

             </Container>
        );
    }


}



Dashboards.propTypes = {
  /**
   * The small stats dataset.
   */
  smallStats: PropTypes.array
};

Dashboards.defaultProps = {
  smallStats: [
    {
      label: "Accounts",
      value: "7",
      percentage: "42.7%",
      increase: true,
      chartLabels: [null, null, null, null, null, null, null],
      attrs: { md: "6", sm: "6" },
      datasets: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: "rgba(0, 184, 216, 0.1)",
          borderColor: "rgb(0, 184, 216)",
          data: [1, 2, 2, 3, 5, 5, 7]
        }
      ]
    },
    {
      label: "Users",
      value: "358",
      percentage: "12.4",
      increase: true,
      decrease: true,
      chartLabels: [null, null, null, null, null, null, null],
      attrs: { md: "6", sm: "6" },
      datasets: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: "rgba(255,180,0,0.1)",
          borderColor: "rgb(255,180,0)",
          data: [1, 2, 3, 4, 5, 7, 8]
        }
      ]
    },
    {
       label: "Engines",
       value: "19",
       percentage: "22.71%",
       increase: true,
       chartLabels: [null, null, null, null, null, null, null],
       attrs: { md: "4", sm: "6" },
       datasets: [
         {
           label: "Today",
           fill: "start",
           borderWidth: 1.5,
           backgroundColor: "rgba(255,65,105,0.1)",
           borderColor: "rgb(255,65,105)",
           data: [2, 3, 3, 4, 5, 6, 8]
         }
       ]
    }
  ]
};

Dashboards.contextTypes = {
  t: PropTypes.func.isRequired
}

export default connect(state => ({
  lang: state.i18nState.lang
}))(Dashboards)